import './App.scss';

import Categories from './components/Section/Categories';

function App() {
  return (
    <div>
      <section>
        <h1> IKEA Restaurant Menu </h1>
        <Categories />
      </section>
    </div>
  );
}

export default App;
